import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AccountsProvider from 'providers/AccountsProvider';
import { AttendanceProvider } from 'providers/AttendanceContext';
import AuthProvider from 'providers/AuthProvider';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import CalendarProvider from 'providers/CalendarProvider';
import NotistackProvider from 'providers/NotistackProvider';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import SettingsProvider from 'providers/SettingsProvider';
import SocketProvider from 'providers/SocketProvider';
import ThemeProvider from 'providers/ThemeProvider';
import { NotificationProvider } from 'providers/notificationContext';
import { PermissionProvider } from 'providers/permissionProvider';
import router from 'routes/router';
import SWRConfiguration from 'services/configuration/SWRConfiguration';
import './locales/i18n';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SWRConfiguration>
      <SettingsProvider>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <NotistackProvider>
              <BreakpointsProvider>
                <SettingsPanelProvider>
                  <CalendarProvider>
                    <AccountsProvider>
                      <AuthProvider>
                        <PermissionProvider>
                          <AttendanceProvider>
                            <NotificationProvider>
                              <SocketProvider>
                                <RouterProvider router={router} />
                              </SocketProvider>
                            </NotificationProvider>
                          </AttendanceProvider>
                        </PermissionProvider>
                      </AuthProvider>
                    </AccountsProvider>
                  </CalendarProvider>
                </SettingsPanelProvider>
              </BreakpointsProvider>
            </NotistackProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </SettingsProvider>
    </SWRConfiguration>
  </React.StrictMode>,
);
